import { render } from "./report.vue?vue&type=template&id=65388ab9&scoped=true"
import script from "./report.vue?vue&type=script&lang=js"
export * from "./report.vue?vue&type=script&lang=js"

import "./report.vue?vue&type=style&index=0&id=65388ab9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-65388ab9"

export default script